/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLabelFilled = createReactComponent("filled", "label-filled", "IconLabelFilled", [["path", { "d": "M16.52 6a2 2 0 0 1 1.561 .75l3.7 4.625a1 1 0 0 1 0 1.25l-3.7 4.624a2 2 0 0 1 -1.561 .751h-10.52a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconLabelFilled as default };
//# sourceMappingURL=IconLabelFilled.mjs.map
